export default __webpack_public_path__ + "static/media/People celebrating Thanksgiving-rafiki.b9b8bde7.svg";